// src/types/rule-engine/rule-template.ts
var RULE_TEMPLATE_IDS = [
  "complements_and_recommendations",
  "line_item_transformation",
  "mutually_exclusive",
  "update_after_hours",
  "merge_complements",
  "inherit_formula",
  "split_line_items",
  "default_quantities",
  "add_f9_note",
  "multi_parent_transformations",
  "multi_parent_recommendations",
  "paint_affected_and_continuous_surface",
  "generate_from_estimate_field",
  "one_line_item_updates_another",
  "bulk_transform_line_items"
];
var INCLUDE_OR_EXCLUDE_VALUES = ["INCLUDE", "EXCLUDE"];

// src/types/rule-engine/query-fields.ts
var RuleQueryFieldType = /* @__PURE__ */ ((RuleQueryFieldType2) => {
  RuleQueryFieldType2["String"] = "string";
  RuleQueryFieldType2["Number"] = "number";
  RuleQueryFieldType2["Boolean"] = "boolean";
  RuleQueryFieldType2["Enum"] = "enum";
  RuleQueryFieldType2["LineItem"] = "lineItem";
  RuleQueryFieldType2["Organizations"] = "organizations";
  RuleQueryFieldType2["Tpas"] = "tpas";
  RuleQueryFieldType2["Carriers"] = "carriers";
  RuleQueryFieldType2["CatCodes"] = "catCodes";
  return RuleQueryFieldType2;
})(RuleQueryFieldType || {});

// src/types/estimate.ts
var EstimateStatus = /* @__PURE__ */ ((EstimateStatus2) => {
  EstimateStatus2["ALL"] = "All";
  EstimateStatus2["NO_STATUS"] = "";
  EstimateStatus2["RECEIVED"] = "Received";
  EstimateStatus2["IN_PROGRESS"] = "In progress";
  EstimateStatus2["WAITING_ON_INFORMATION"] = "Waiting on information";
  EstimateStatus2["UNDER_REVIEW"] = "Under review";
  EstimateStatus2["FINAL_REVIEW"] = "Final review";
  EstimateStatus2["APPROVED"] = "Approved";
  EstimateStatus2["PAID"] = "Paid";
  EstimateStatus2["CLOSED"] = "Closed";
  return EstimateStatus2;
})(EstimateStatus || {});
var XCELERATE_STATUSES = /* @__PURE__ */ ((XCELERATE_STATUSES2) => {
  XCELERATE_STATUSES2["NEW"] = "New";
  XCELERATE_STATUSES2["ESTIMATING_INITIAL"] = "Estimating (Initial)";
  XCELERATE_STATUSES2["SALES"] = "Sales";
  XCELERATE_STATUSES2["PLANNING"] = "Planning";
  XCELERATE_STATUSES2["ESTIMATING_FINAL"] = "Estimating (Final)";
  XCELERATE_STATUSES2["INVOICING"] = "Invoicing";
  XCELERATE_STATUSES2["RECEIVABLES"] = "Receivables";
  return XCELERATE_STATUSES2;
})(XCELERATE_STATUSES || {});
var EstimateType = /* @__PURE__ */ ((EstimateType2) => {
  EstimateType2["MITIGATION"] = "MITIGATION";
  EstimateType2["RECONSTRUCTION"] = "RECONSTRUCTION";
  EstimateType2["CONTENTS"] = "CONTENTS";
  EstimateType2["MOLD"] = "MOLD";
  EstimateType2["FIRE_MITIGATION"] = "FIRE_MITIGATION";
  EstimateType2["BIOHAZARD"] = "BIOHAZARD";
  EstimateType2["TIME_AND_MATERIAL"] = "TIME_AND_MATERIAL";
  return EstimateType2;
})(EstimateType || {});
var ESTIMATE_TYPE_LABELS = {
  ["MITIGATION" /* MITIGATION */]: "Mitigation",
  ["RECONSTRUCTION" /* RECONSTRUCTION */]: "Reconstruction",
  ["CONTENTS" /* CONTENTS */]: "Contents",
  ["MOLD" /* MOLD */]: "Mold",
  ["FIRE_MITIGATION" /* FIRE_MITIGATION */]: "Fire Mitigation",
  ["BIOHAZARD" /* BIOHAZARD */]: "Biohazard",
  ["TIME_AND_MATERIAL" /* TIME_AND_MATERIAL */]: "Time and Material"
};
var getEstimateTypeLabel = (estimateType) => estimateType ? ESTIMATE_TYPE_LABELS[estimateType] ?? "" : "";
var EstimaticsFileTypes = /* @__PURE__ */ ((EstimaticsFileTypes2) => {
  EstimaticsFileTypes2["tic"] = "tic";
  EstimaticsFileTypes2["image"] = "image";
  EstimaticsFileTypes2["other"] = "other";
  EstimaticsFileTypes2["MITIGATION_REPORT"] = "mitigation_report";
  EstimaticsFileTypes2["CONTENTS_TEMPLATE"] = "contents_template";
  EstimaticsFileTypes2["XACTIMATE_ESTIMATE"] = "xactimate_estimate";
  return EstimaticsFileTypes2;
})(EstimaticsFileTypes || {});
var ScopeNoteSource = {
  DOCUSKETCH: "DOCUSKETCH",
  UPLOADED: "UPLOADED",
  VOICE: "VOICE",
  MICA: "MICA",
  CONTENTS: "CONTENTS",
  FREE_FORM_TIC_SHEET: "FREE_FORM_TIC_SHEET",
  XCELERATE: "XCELERATE"
};
var EstimateCreationSource = /* @__PURE__ */ ((EstimateCreationSource2) => {
  EstimateCreationSource2["REBUILD"] = "REBUILD";
  EstimateCreationSource2["REBUILD_WEB"] = "REBUILD_WEB";
  EstimateCreationSource2["REBUILD_MOBILE"] = "REBUILD_MOBILE";
  EstimateCreationSource2["XCELERATE"] = "XCELERATE";
  EstimateCreationSource2["GOOGLE_FORM"] = "GOOGLE_FORM";
  EstimateCreationSource2["JOB_NIMBUS"] = "JOB_NIMBUS";
  EstimateCreationSource2["FIRST_ATLANTIC"] = "FIRST_ATLANTIC";
  EstimateCreationSource2["ALBI"] = "ALBI";
  EstimateCreationSource2["PSA"] = "PSA";
  return EstimateCreationSource2;
})(EstimateCreationSource || {});
var EstimateReferenceNumberType = /* @__PURE__ */ ((EstimateReferenceNumberType2) => {
  EstimateReferenceNumberType2["UNKNOWN"] = "UNKNOWN";
  EstimateReferenceNumberType2["XCELERATE"] = "XCELERATE";
  EstimateReferenceNumberType2["JOB_NIMBUS"] = "JOB_NIMBUS";
  EstimateReferenceNumberType2["FIRST_ATLANTIC"] = "FIRST_ATLANTIC";
  EstimateReferenceNumberType2["ALBI"] = "ALBI";
  EstimateReferenceNumberType2["PSA"] = "PSA";
  return EstimateReferenceNumberType2;
})(EstimateReferenceNumberType || {});
var NoteType = /* @__PURE__ */ ((NoteType2) => {
  NoteType2["MITIGATION"] = "Mitigation";
  NoteType2["INTERIOR_RECONSTRUCTION"] = "Interior Reconstruction";
  NoteType2["EXTERIOR_RECONSTRUCTION"] = "Exterior Reconstruction";
  NoteType2["CONTENTS"] = "Contents";
  NoteType2["MOLD"] = "Mold";
  NoteType2["FIRE_MITIGATION"] = "Fire Mitigation";
  NoteType2["BIOHAZARD"] = "Biohazard";
  NoteType2["TIME_AND_MATERIAL"] = "Time and Material";
  return NoteType2;
})(NoteType || {});
var NOTE_TYPE_TO_ESTIMATE_TYPE = {
  ["Mitigation" /* MITIGATION */]: "MITIGATION" /* MITIGATION */,
  ["Interior Reconstruction" /* INTERIOR_RECONSTRUCTION */]: "RECONSTRUCTION" /* RECONSTRUCTION */,
  ["Exterior Reconstruction" /* EXTERIOR_RECONSTRUCTION */]: "RECONSTRUCTION" /* RECONSTRUCTION */,
  ["Contents" /* CONTENTS */]: "CONTENTS" /* CONTENTS */,
  ["Mold" /* MOLD */]: "MOLD" /* MOLD */,
  ["Fire Mitigation" /* FIRE_MITIGATION */]: "FIRE_MITIGATION" /* FIRE_MITIGATION */,
  ["Biohazard" /* BIOHAZARD */]: "BIOHAZARD" /* BIOHAZARD */,
  ["Time and Material" /* TIME_AND_MATERIAL */]: "TIME_AND_MATERIAL" /* TIME_AND_MATERIAL */
};
var NOTE_TYPE_VALUES = Object.keys(NOTE_TYPE_TO_ESTIMATE_TYPE);
var getNoteTypeFromEstimateType = (estimateType) => {
  if (!estimateType) return "Mitigation" /* MITIGATION */;
  if (estimateType === "MITIGATION" /* MITIGATION */) return "Mitigation" /* MITIGATION */;
  if (estimateType === "CONTENTS" /* CONTENTS */) return "Contents" /* CONTENTS */;
  if (estimateType === "MOLD" /* MOLD */) return "Mold" /* MOLD */;
  if (estimateType === "FIRE_MITIGATION" /* FIRE_MITIGATION */) return "Fire Mitigation" /* FIRE_MITIGATION */;
  if (estimateType === "BIOHAZARD" /* BIOHAZARD */) return "Biohazard" /* BIOHAZARD */;
  if (estimateType === "TIME_AND_MATERIAL" /* TIME_AND_MATERIAL */) return "Time and Material" /* TIME_AND_MATERIAL */;
  return "Interior Reconstruction" /* INTERIOR_RECONSTRUCTION */;
};
var ResponsiveNoteTemplateVisitType = /* @__PURE__ */ ((ResponsiveNoteTemplateVisitType2) => {
  ResponsiveNoteTemplateVisitType2["INITIAL"] = "INITIAL";
  ResponsiveNoteTemplateVisitType2["SUBSEQUENT"] = "SUBSEQUENT";
  return ResponsiveNoteTemplateVisitType2;
})(ResponsiveNoteTemplateVisitType || {});
var NoteFlowType = /* @__PURE__ */ ((NoteFlowType2) => {
  NoteFlowType2["REESE"] = "reese";
  NoteFlowType2["MODULES"] = "modules";
  NoteFlowType2["DEFAULT"] = "default";
  return NoteFlowType2;
})(NoteFlowType || {});
var GeneralRoomOrder = /* @__PURE__ */ ((GeneralRoomOrder2) => {
  GeneralRoomOrder2["START"] = "start";
  GeneralRoomOrder2["END"] = "end";
  return GeneralRoomOrder2;
})(GeneralRoomOrder || {});
var VerboseSowPdfMode = /* @__PURE__ */ ((VerboseSowPdfMode2) => {
  VerboseSowPdfMode2["WITH_LINE_ITEM_PRICES"] = "WITH_LINE_ITEM_PRICES";
  VerboseSowPdfMode2["WITHOUT_LINE_ITEM_PRICES"] = "WITHOUT_LINE_ITEM_PRICES";
  return VerboseSowPdfMode2;
})(VerboseSowPdfMode || {});

// src/types/rule-engine/templates/rule_run_criteria.ts
var RULE_RUN_CRITERIA = [
  {
    name: "organizations",
    type: "organizations"
  },
  {
    name: "catNumbers",
    type: "catCodes"
  },
  {
    name: "estimateType",
    type: "enum",
    values: [...Object.values(EstimateType)]
  },
  {
    name: "tpas",
    type: "tpas"
  },
  {
    name: "carriers",
    type: "carriers"
  },
  {
    name: "isMitToRecon",
    type: "boolean"
  }
];

// src/types/rule-engine/templates/add_f9_note.ts
var ADD_F9_NOTE = {
  name: "add f9 note",
  id: "add_f9_note",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "lineItem",
        name: "lineItem",
        description: "The line item to add the F9 note to",
        parameters: {
          enablePartialSelection: true
        }
      },
      {
        type: "string",
        name: "f9Note",
        multiline: true,
        //optional, since multiline has been manually enabled in the golasso db
        description: "The F9 note text to append to the line item's existing F9 note. Use ${N} to insert the quantity extracted from the matching line item's formula. Supports arithmetic: ${N / 2}, ${N * 3}, ${N + 1}, ${N - 5}. Throws an error if ${N} is used but the quantity cannot be extracted."
      }
    ]
  }
};

// src/constants/xactimate.ts
var XACTIMATE_CATEGORIES = [
  "ACC",
  "ACT",
  "APP",
  "ARC",
  "AWN",
  "CAB",
  "CAP",
  "CDC",
  "CEL",
  "CGN",
  "CGN CONT",
  "CHF",
  "CHF CONT",
  "CLN",
  "CNC",
  "CON",
  "CPS",
  "CPS CONT",
  "CUP",
  "CUP CONT",
  "CWH",
  "CWH CONT",
  "DMO",
  "DOR",
  "DRY",
  "ELE",
  "ELS",
  "EQA",
  "EQC",
  "EQU",
  "EXC",
  "FCC",
  "FCR",
  "FCS",
  "FCT",
  "FCV",
  "FCW",
  "FEE",
  "FEN",
  "FNC",
  "FNH",
  "FPL",
  "FPS",
  "FRM",
  "GLS",
  "HMR",
  "HVC",
  "INM",
  "INS",
  "LAB",
  "LIT",
  "LND",
  "MAS",
  "MBL",
  "MPR",
  "MSD",
  "MSK",
  "MTL",
  "ORI",
  "PLA",
  "PLM",
  "PNL",
  "PNT",
  "POL",
  "PTG",
  "RFG",
  "SCF",
  "SDG",
  "SFG",
  "SPE",
  "STJ",
  "STL",
  "STR",
  "STU",
  "TBA",
  "TCR",
  "TIL",
  "TMB",
  "TMP",
  "USR",
  "VTC",
  "WDA",
  "WDP",
  "WDR",
  "WDS",
  "WDT",
  "WDV",
  "WDW",
  "WPR",
  "WTR",
  "XST"
];
var ACTIVITY_KEYWORDS = [
  [" remove and replace ", "&"],
  [" r&r ", "&"],
  [" r & r ", "&"],
  [" remove ", "-"],
  [" removal ", "-"],
  [" demo ", "-"],
  [" demolish ", "-"],
  [" tear out ", "-"],
  [" tear off ", "-"],
  [" replace ", "+"],
  [" install only ", "i"],
  [" material only ", "m"],
  [" detach and reset ", "r"],
  [" detach & reset ", "r"],
  [" d&r ", "r"],
  [" reset ", "r"]
];
function getDefaultActivity(lineItem) {
  const text = ` ${lineItem.toLowerCase()} `;
  const match = ACTIVITY_KEYWORDS.find(([kw]) => text.includes(kw));
  return match ? match[1] : "+";
}

// src/types/rule-engine/templates/bulk_transform_line_items.ts
var BULK_TRANSFORM_LINE_ITEMS = {
  name: "bulk transform line items",
  id: "bulk_transform_line_items",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "enum",
        name: "categories",
        isMultiSelect: true,
        values: [...XACTIMATE_CATEGORIES],
        description: "Match on every line item whose Xactimate category is one of the selected categories."
      },
      {
        type: "array",
        name: "includedLineItems",
        description: "Individual line items to match on, in addition to the selected categories.",
        items: [
          {
            type: "lineItem",
            name: "lineItem",
            parameters: {
              enablePartialSelection: true
            }
          }
        ]
      },
      {
        type: "array",
        name: "excludedLineItems",
        description: "Individual line items to exclude from matching. Use this to skip specific line items inside a category that is otherwise matched on.",
        items: [
          {
            type: "lineItem",
            name: "lineItem",
            parameters: {
              enablePartialSelection: true
            }
          }
        ]
      },
      {
        type: "boolean",
        name: "shouldExclude",
        description: "If set to true, every matched line item will have its `removedByTPARule` flag set."
      }
    ]
  }
};

// src/types/estimate-engine.ts
var Kind = /* @__PURE__ */ ((Kind2) => {
  Kind2["ColumnHeader"] = "columnHeader";
  Kind2["Content"] = "content";
  return Kind2;
})(Kind || {});
var TicSheetType = /* @__PURE__ */ ((TicSheetType2) => {
  TicSheetType2["None"] = "";
  TicSheetType2["Type1"] = "Type1";
  TicSheetType2["Type1_1"] = "Type1_1";
  TicSheetType2["Exterior"] = "exterior";
  return TicSheetType2;
})(TicSheetType || {});
var EstimateFieldsForExportHeader = /* @__PURE__ */ ((EstimateFieldsForExportHeader2) => {
  EstimateFieldsForExportHeader2["ProjectName"] = "projectName";
  EstimateFieldsForExportHeader2["PropertyAddress"] = "propertyAddress";
  EstimateFieldsForExportHeader2["Assignee"] = "assignee";
  EstimateFieldsForExportHeader2["CurrentDate"] = "currentDate";
  EstimateFieldsForExportHeader2["OrganizationName"] = "organizationName";
  return EstimateFieldsForExportHeader2;
})(EstimateFieldsForExportHeader || {});
var TPARuleTypes = /* @__PURE__ */ ((TPARuleTypes2) => {
  TPARuleTypes2["RemoveComplement"] = "Remove Complement";
  TPARuleTypes2["ConvertToLikelyComplement"] = "Convert to likely complement";
  TPARuleTypes2["AdditionalComplements"] = "Additional complements";
  TPARuleTypes2["SplitUpLineItems"] = "Split up Line Items";
  TPARuleTypes2["RolledFlooringWasteCalculation"] = "Rolled Flooring Waste Calculation";
  TPARuleTypes2["AlternativeMaximum"] = "Alternative maximum";
  TPARuleTypes2["AlternateXactimateCoding"] = "Alternate Xactimate coding";
  TPARuleTypes2["ConRoomToConLab"] = "Convert Room to Con Lab or vice versa";
  return TPARuleTypes2;
})(TPARuleTypes || {});
var DayOfWeek = /* @__PURE__ */ ((DayOfWeek2) => {
  DayOfWeek2["SUN"] = "SUN";
  DayOfWeek2["MON"] = "MON";
  DayOfWeek2["TUE"] = "TUE";
  DayOfWeek2["WED"] = "WED";
  DayOfWeek2["THU"] = "THU";
  DayOfWeek2["FRI"] = "FRI";
  DayOfWeek2["SAT"] = "SAT";
  return DayOfWeek2;
})(DayOfWeek || {});
var Holiday = /* @__PURE__ */ ((Holiday2) => {
  Holiday2["NEW_YEARS_DAY"] = "New Year's Day";
  Holiday2["MARTIN_LUTHER_KING_JR_DAY"] = "Martin Luther King Jr. Day";
  Holiday2["PRESIDENTS_DAY"] = "Presidents' Day";
  Holiday2["MEMORIAL_DAY"] = "Memorial Day";
  Holiday2["INDEPENDENCE_DAY"] = "Independence Day";
  Holiday2["LABOR_DAY"] = "Labor Day";
  Holiday2["COLUMBUS_DAY"] = "Columbus Day";
  Holiday2["INDIGENOUS_PEOPLES_DAY"] = "Indigenous Peoples' Day";
  Holiday2["VETERANS_DAY"] = "Veterans Day";
  Holiday2["THANKSGIVING"] = "Thanksgiving";
  Holiday2["CHRISTMAS"] = "Christmas";
  return Holiday2;
})(Holiday || {});
var RoomType = /* @__PURE__ */ ((RoomType2) => {
  RoomType2["STORAGE"] = "STORAGE";
  RoomType2["STAIRS"] = "STAIRS";
  RoomType2["PATIO__DECK"] = "PATIO/DECK";
  RoomType2["OFFICE"] = "OFFICE";
  RoomType2["MECHANICAL"] = "MECHANICAL";
  RoomType2["LAUNDRY"] = "LAUNDRY";
  RoomType2["KITCHEN"] = "KITCHEN";
  RoomType2["HALLWAY"] = "HALLWAY";
  RoomType2["GYM"] = "GYM";
  RoomType2["OTHER"] = "OTHER";
  RoomType2["GARAGE"] = "GARAGE";
  RoomType2["FAMILY_ROOM__LIVING_ROOM__DEN"] = "FAMILY ROOM/LIVING ROOM/DEN";
  RoomType2["EXTERIOR__ROOF"] = "EXTERIOR/ROOF";
  RoomType2["ENTRY__FOYER"] = "ENTRY/FOYER";
  RoomType2["DINING_ROOM"] = "DINING ROOM";
  RoomType2["CRAWL_SPACE"] = "CRAWL SPACE";
  RoomType2["CLOSET"] = "CLOSET";
  RoomType2["BEDROOM"] = "BEDROOM";
  RoomType2["BATHROOM"] = "BATHROOM";
  RoomType2["BASEMENT"] = "BASEMENT";
  RoomType2["ATTIC"] = "ATTIC";
  return RoomType2;
})(RoomType || {});
var ESkipProcessingReason = /* @__PURE__ */ ((ESkipProcessingReason2) => {
  ESkipProcessingReason2["NotTicSheet"] = "not-tic-sheet";
  ESkipProcessingReason2["UnsupportedTicType"] = "unsupported-tic-type";
  ESkipProcessingReason2["BadDocumentAngle"] = "bad-document-angle";
  ESkipProcessingReason2["NoCellsWithInput"] = "no-cells-with-input";
  return ESkipProcessingReason2;
})(ESkipProcessingReason || {});
var ScopeTag = /* @__PURE__ */ ((ScopeTag2) => {
  ScopeTag2["water_mitigation"] = "water_mitigation";
  ScopeTag2["interior_reconstruction"] = "interior_reconstruction";
  ScopeTag2["exterior_reconstruction"] = "exterior_reconstruction";
  ScopeTag2["contents"] = "contents";
  ScopeTag2["mold"] = "mold";
  ScopeTag2["fire_mitigation"] = "fire_mitigation";
  ScopeTag2["biohazard"] = "biohazard";
  ScopeTag2["time_and_material"] = "time_and_material";
  return ScopeTag2;
})(ScopeTag || {});
var QueuedItemToProcessStatus = /* @__PURE__ */ ((QueuedItemToProcessStatus2) => {
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["None"] = 0] = "None";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["Queued"] = 10] = "Queued";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["Extracted"] = 20] = "Extracted";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["Classified"] = 30] = "Classified";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["LayoutAndReadExtracted"] = 40] = "LayoutAndReadExtracted";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["CellsExtracted"] = 50] = "CellsExtracted";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["RawDataFromCellsExtracted"] = 60] = "RawDataFromCellsExtracted";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["CellWithInputExtracted"] = 70] = "CellWithInputExtracted";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["CellImproveWithOpenAICompleted"] = 80] = "CellImproveWithOpenAICompleted";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["LineItemDatabaseCreated"] = 90] = "LineItemDatabaseCreated";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["ComplementLineItemsCreated"] = 91] = "ComplementLineItemsCreated";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["UILineItemDatabaseCreated"] = 93] = "UILineItemDatabaseCreated";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["FinalEstimateCreated"] = 97] = "FinalEstimateCreated";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["Completed"] = 100] = "Completed";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["CompletedNotProcessed"] = 110] = "CompletedNotProcessed";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["CompletedWithError"] = 120] = "CompletedWithError";
  QueuedItemToProcessStatus2[QueuedItemToProcessStatus2["CompletedActingAsATracker"] = 130] = "CompletedActingAsATracker";
  return QueuedItemToProcessStatus2;
})(QueuedItemToProcessStatus || {});
var PdfFileFormat = /* @__PURE__ */ ((PdfFileFormat2) => {
  PdfFileFormat2["SERVPRO_DRYBOOK"] = "SERVPRO_DRYBOOK";
  PdfFileFormat2["CLEVELAND_TIC_SHEET"] = "CLEVELAND_TIC_SHEET";
  PdfFileFormat2["BELFOR_MIT"] = "BELFOR_MIT";
  PdfFileFormat2["SERVICE_MASTER_GO_FORMZ"] = "SERVICE_MASTER_GO_FORMZ";
  PdfFileFormat2["SERVICE_MASTER_CORNERSTONE"] = "SERVICE_MASTER_CORNERSTONE";
  PdfFileFormat2["MICA_REPORT"] = "MICA_REPORT";
  PdfFileFormat2["SERVICE_MASTER_SCOPE_OF_WORK_DOC"] = "SERVICE_MASTER_SCOPE_OF_WORK_DOC";
  PdfFileFormat2["XACTIMATE_ESTIMATE"] = "XACTIMATE_ESTIMATE";
  PdfFileFormat2["OTHER"] = "OTHER";
  return PdfFileFormat2;
})(PdfFileFormat || {});
var EDrywallWidthCalculation = /* @__PURE__ */ ((EDrywallWidthCalculation2) => {
  EDrywallWidthCalculation2["W"] = "W";
  EDrywallWidthCalculation2["W_AffectedMaterial"] = "W - affected material";
  return EDrywallWidthCalculation2;
})(EDrywallWidthCalculation || {});
var PFWidthCalculation = /* @__PURE__ */ ((PFWidthCalculation2) => {
  PFWidthCalculation2["PF"] = "PF";
  PFWidthCalculation2["PF_AffectedMaterial"] = "PF - affected material";
  return PFWidthCalculation2;
})(PFWidthCalculation || {});
var PCWidthCalculation = /* @__PURE__ */ ((PCWidthCalculation2) => {
  PCWidthCalculation2["PC"] = "PC";
  PCWidthCalculation2["PC_AffectedMaterial"] = "PC - affected material";
  return PCWidthCalculation2;
})(PCWidthCalculation || {});
var EExtraVariableValues = /* @__PURE__ */ ((EExtraVariableValues2) => {
  EExtraVariableValues2["NotAvailable"] = "not available";
  EExtraVariableValues2["TicSheetError"] = "Mark as tic sheet error";
  EExtraVariableValues2["CreateNewVariable"] = "Add new variable";
  EExtraVariableValues2["UseLineMarker"] = "Use Line Marker";
  EExtraVariableValues2["AcceptVariableDependency"] = "Accept Dependency";
  EExtraVariableValues2["AcceptInvertedVariableDependency"] = "Accept Inverted Dependency";
  return EExtraVariableValues2;
})(EExtraVariableValues || {});
var _EExtraDataMappingType = class _EExtraDataMappingType {
  static isError(type) {
    return type === _EExtraDataMappingType.NoEmptyValueNoDefault || type === _EExtraDataMappingType.NotAllMappingsUsed || type === _EExtraDataMappingType.UnitNotMatching || type === _EExtraDataMappingType.InputWithNoMapping || type === _EExtraDataMappingType.LowConfidenceInput || type === _EExtraDataMappingType.QuantityOutOfRange || type === _EExtraDataMappingType.QuantityOutOfRangeTPARule || type === _EExtraDataMappingType.NoUnit || type === _EExtraDataMappingType.NoQuantity;
  }
};
// errors
_EExtraDataMappingType.NoEmptyValueNoDefault = "no-empty-value-no-default";
_EExtraDataMappingType.NotAllMappingsUsed = "not-all-mappings-used";
_EExtraDataMappingType.UnitNotMatching = "unit-not-matching";
_EExtraDataMappingType.InputWithNoMapping = "input-with-no-mapping";
_EExtraDataMappingType.QuantityOutOfRange = "quantity-out-of-range";
_EExtraDataMappingType.QuantityOutOfRangeTPARule = "quantity-out-of-range-tpa-rule";
_EExtraDataMappingType.LowConfidenceInput = "low-confidence-input";
_EExtraDataMappingType.NoUnit = "no-unit";
_EExtraDataMappingType.NoQuantity = "no-quantity";
// modifiers
_EExtraDataMappingType.QuantityModifier = "quantity-modifier";
var EExtraDataMappingType = _EExtraDataMappingType;
var FileErrorDummyPath = "~";
function getQueuedItemToProcessStatusName(status) {
  switch (status) {
    case 0 /* None */:
      return "None";
    case 10 /* Queued */:
      return "Queued";
    case 20 /* Extracted */:
      return "Extracted";
    case 30 /* Classified */:
      return "Classified";
    case 40 /* LayoutAndReadExtracted */:
      return "LayoutAndReadExtracted";
    case 50 /* CellsExtracted */:
      return "CellsExtracted";
    case 60 /* RawDataFromCellsExtracted */:
      return "RawDataFromCellsExtracted";
    case 70 /* CellWithInputExtracted */:
      return "CellWithInputExtracted";
    case 80 /* CellImproveWithOpenAICompleted */:
      return "CellImproveWithOpenAICompleted";
    case 90 /* LineItemDatabaseCreated */:
      return "LineItemDatabaseCreated";
    case 100 /* Completed */:
      return "Completed";
    case 110 /* CompletedNotProcessed */:
      return "CompletedNotProcessed";
    case 120 /* CompletedWithError */:
      return "CompletedWithError";
    case 93 /* UILineItemDatabaseCreated */:
      return "UILineItemDatabaseCreated";
    case 97 /* FinalEstimateCreated */:
      return "FinalEstimateCreated";
  }
  return "Unknown";
}
var ESTIMATE_TYPE_TO_TAGS = {
  MITIGATION: ["water_mitigation" /* water_mitigation */],
  RECONSTRUCTION: ["interior_reconstruction" /* interior_reconstruction */, "exterior_reconstruction" /* exterior_reconstruction */],
  CONTENTS: ["contents" /* contents */],
  MOLD: ["mold" /* mold */],
  FIRE_MITIGATION: ["fire_mitigation" /* fire_mitigation */],
  BIOHAZARD: ["biohazard" /* biohazard */],
  TIME_AND_MATERIAL: ["time_and_material" /* time_and_material */]
};

// src/types/rule-engine/templates/complements_and_recommendations.ts
var CHILDREN_ITEM_FIELDS = [
  {
    name: "lineItem",
    type: "lineItem",
    parameters: {
      canBeDifferentFromSource: true,
      sourceLineItemPath: "ruleInputs.parent"
    }
  },
  {
    name: "isLikely",
    type: "boolean",
    description: "If checked, then the child will be a recommendation; if un-checked, then the child will be a complement."
  },
  {
    name: "isComplimentIfMitToRecon",
    type: "boolean",
    description: "If checked and the estimate is a mit-to-recon, make this child line item a compliment even if `isLikely` is set to true"
  },
  {
    name: "inheritParentAction",
    type: "boolean",
    description: "If true, child will inherit the parent's action variable (e.g. 'remove', 'remove and replace', etc)"
  },
  {
    name: "quantityFunction",
    type: "enum",
    values: ["INHERIT", "MULTIPLY", "USE_DEFAULT", "FORMULA_FUNCTION"],
    description: "This field determines the relationship between the child's quantity and its parent's quantity. This is used with the following field, 'quantity generation constant', to generate the child's quantity."
  },
  {
    name: "quantityValue",
    type: "string",
    description: "This field is used differently based on the selected 'quantity generation'. If 'quantity generation' is 'multiply', then multiply the parent's quantity by this number to get the child's quantity; if it's 'use default', then use this number directly for the child's quantity; if it's 'inherit', then this number is ignored."
  },
  {
    name: "overrideExistingLineItem",
    type: "boolean",
    description: "If set to true, then override any existing line item with this complement."
  }
];
var COMPLEMENTS_AND_RECOMMENDATIONS = {
  name: "complements and recommendations",
  id: "complements_and_recommendations",
  inputField: {
    name: "ruleInputs",
    properties: [
      {
        type: "lineItem",
        name: "parent",
        parameters: {
          enablePartialSelection: true
        }
      },
      {
        name: "roomTypes",
        type: "enum",
        values: [...Object.values(RoomType)],
        isMultiSelect: true
      },
      {
        properties: CHILDREN_ITEM_FIELDS,
        type: "object",
        name: "child"
      },
      {
        description: "You can use this field to have different children based on a specific permutation of the line item.",
        items: [
          {
            name: "permutation",
            parameters: {
              sourceLineItemPath: "ruleInputs.parent",
              enablePartialSelection: true
            },
            type: "lineItem"
          },
          {
            description: "If this is set to true, then no children line items will be generated for this specific permutation.",
            name: "doNotCreateChild",
            type: "boolean"
          },
          {
            properties: RULE_RUN_CRITERIA,
            type: "object",
            name: "runCriteria"
          },
          {
            name: "roomTypes",
            type: "enum",
            values: [...Object.values(RoomType)],
            isMultiSelect: true
          },
          {
            properties: CHILDREN_ITEM_FIELDS,
            name: "child",
            type: "object"
          }
        ],
        type: "array",
        name: "overrides"
      }
    ],
    type: "object"
  }
};

// src/types/rule-engine/templates/default_quantities.ts
var DEFAULT_QUANTITIES_FORMULA_FIELDS = [
  {
    type: "enum",
    name: "quantityFunction",
    values: ["USE_DEFAULT", "MULTIPLY_BY"],
    description: "How to calculate the new formula. USE_DEFAULT uses quantityValue as the raw formula. MULTIPLY_BY multiplies the parent's formula by quantityValue."
  },
  {
    type: "string",
    name: "quantityValue",
    description: "The value to use for the quantity calculation. For USE_DEFAULT, this is the raw formula (e.g., '5SF'). For MULTIPLY_BY, this is the multiplier (e.g., '5')."
  }
];
var DEFAULT_QUANTITIES = {
  name: "default quantities",
  id: "default_quantities",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "lineItem",
        name: "lineItem",
        description: "The line item to apply default quantity conversion to",
        parameters: {
          enablePartialSelection: true
        }
      },
      ...DEFAULT_QUANTITIES_FORMULA_FIELDS,
      {
        type: "array",
        name: "overrides",
        description: "Override the default quantityFunction and quantityValue for specific line item permutations.",
        items: [
          {
            type: "lineItem",
            name: "permutation",
            description: "The specific permutation to match for this override",
            parameters: {
              sourceLineItemPath: "ruleInputs.lineItem",
              enablePartialSelection: true
            }
          },
          ...DEFAULT_QUANTITIES_FORMULA_FIELDS
        ]
      }
    ]
  }
};

// src/types/rule-engine/templates/generate_from_estimate_field.ts
var GENERATE_FROM_ESTIMATE_FIELD = {
  name: "generate from estimate field",
  id: "generate_from_estimate_field",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "enum",
        name: "estimateField",
        values: ["projectDuration"],
        description: "The estimate field whose value drives the generated line item's quantity."
      },
      {
        type: "quantityFunction",
        name: "quantity",
        options: ["USE_DEFAULT", "MULTIPLY_BY"],
        description: "How to turn the estimate field's value into the line item's quantity. USE_DEFAULT uses the value as the raw quantity. MULTIPLY_BY multiplies the field's value by the value."
      },
      {
        type: "lineItem",
        name: "complementLineItem",
        description: "The complement/recommendation line item to generate (template id + permutation).",
        parameters: {
          canBeDifferentFromSource: true
        }
      },
      {
        type: "boolean",
        name: "isLikely",
        description: "When true, generate a recommendation; otherwise a complement."
      }
    ]
  }
};

// src/types/rule-engine/templates/inherit_formula.ts
var INHERIT_FORMULA = {
  name: "inherit formula",
  id: "inherit_formula",
  inputField: {
    name: "ruleInputs",
    properties: [
      {
        type: "lineItem",
        name: "parentLineItem",
        parameters: {
          enablePartialSelection: true
        }
      },
      {
        type: "lineItem",
        name: "childLineItem",
        parameters: {
          enablePartialSelection: true
        }
      },
      {
        type: "string",
        name: "formulaFunction",
        description: `Please enter the formula and use "{N}" to denote where to place the parent line item's formula. The parent's formula will be converted to the child's units first before being inserted into this formula string`
      },
      {
        type: "boolean",
        name: "skipIfUserGenerated",
        description: "Skip If User Generated - If set to true, will skip the formula inheritance for line items generated directly from user-submitted documentation, line items manually added by the user, or line items confirmed by the user."
      }
    ],
    type: "object"
  }
};

// src/types/rule-engine/templates/line_item_transformation.ts
var TRANSFORMATION_OPTIONS = [
  {
    type: "number",
    name: "initialQuantityStart",
    description: "If set, defines lower bound of range of quantities to match on."
  },
  {
    type: "number",
    name: "initialQuantityEnd",
    description: "If set, defines upper bound of range of quantities to match on."
  },
  {
    type: "enum",
    name: "quantityConversionType",
    values: ["MAX_VALUE", "MULTIPLY", "USE_DEFAULT"]
  },
  {
    type: "string",
    name: "quantityConversionValue",
    description: "Used with `quantityConversionType` to perform a specific transformation on the matching line item's formula"
  },
  {
    type: "boolean",
    name: "shouldRemove",
    description: "If set to true, the matching line item will be removed from the line item"
  },
  {
    type: "lineItem",
    name: "finalLineItem",
    description: "If set, will transform the matching line item into the line item set here. If this has the same line-item-id as the initial line item, then let the user select variable overrides instead of selecting the entire permutation",
    parameters: {
      canBeDifferentFromSource: true,
      sourceLineItemPath: "ruleInputs.initialLineItem"
    }
  },
  {
    type: "boolean",
    name: "skipIfUserGenerated",
    description: "Skip If User Generated - If set to true, will skip the formula inheritance for line items generated directly from user-submitted documentation, line items manually added by the user, or line items confirmed by the user."
  }
];
var LINE_ITEM_TRANSFORMATION = {
  name: "line item transformation",
  id: "line_item_transformation",
  inputField: {
    name: "ruleInputs",
    properties: [
      {
        type: "lineItem",
        name: "initialLineItem",
        parameters: {
          enablePartialSelection: true
        }
      },
      ...TRANSFORMATION_OPTIONS,
      {
        type: "array",
        name: "overrides",
        description: "You can use this field to have different transformation behavior based on a specific permutation of the line item.",
        items: [
          {
            name: "permutation",
            parameters: {
              sourceLineItemPath: "ruleInputs.initialLineItem",
              enablePartialSelection: true
            },
            type: "lineItem"
          },
          {
            properties: RULE_RUN_CRITERIA,
            type: "object",
            name: "runCriteria"
          },
          ...TRANSFORMATION_OPTIONS
        ]
      }
    ],
    type: "object"
  }
};

// src/types/rule-engine/templates/merge_complements.ts
var MERGE_COMPLEMENTS = {
  name: "merge complements",
  id: "merge_complements",
  inputField: {
    name: "ruleInputs",
    properties: [
      {
        type: "array",
        name: "overrides",
        description: "You can use this field to override the default merging behavior for specific line item types.",
        items: [
          {
            name: "lineItem",
            parameters: {
              enablePartialSelection: true
            },
            type: "lineItem",
            description: "The line item type to apply the override to"
          },
          {
            type: "enum",
            name: "quantityMergeType",
            values: ["USE_DEFAULT"],
            description: "How to handle the merged quantity"
          },
          {
            type: "string",
            name: "quantityMergeValue",
            description: "The value to use with the quantityMergeType (max value limit or default quantity)"
          }
        ]
      }
    ],
    type: "object"
  }
};

// src/constants/line-item-constants.ts
var ISSUE_CONFIDENCE_THRESHOLD = 0.6;
var LineItemCategory = /* @__PURE__ */ ((LineItemCategory2) => {
  LineItemCategory2["GENERAL"] = "GENERAL";
  LineItemCategory2["DEMO"] = "DEMO";
  LineItemCategory2["FRAMING"] = "FRAMING";
  LineItemCategory2["WINDOWS"] = "WINDOWS";
  LineItemCategory2["HVAC"] = "HVAC";
  LineItemCategory2["ELECTRICAL"] = "ELECTRICAL";
  LineItemCategory2["PLUMBING"] = "PLUMBING";
  LineItemCategory2["INSULATION"] = "INSULATION";
  LineItemCategory2["DRYWALL"] = "DRYWALL";
  LineItemCategory2["FINISH_CARPENTRY"] = "FINISH CARPENTRY";
  LineItemCategory2["DOORS"] = "DOORS";
  LineItemCategory2["CABINETS_COUNTERTOPS"] = "CABINETS & COUNTERTOPS";
  LineItemCategory2["PAINTING"] = "PAINTING";
  LineItemCategory2["LIGHTING"] = "LIGHTING";
  LineItemCategory2["FLOORING"] = "FLOORING";
  LineItemCategory2["WINDOW_TREATMENTS"] = "WINDOW TREATMENTS";
  LineItemCategory2["CLEANING"] = "CLEANING";
  LineItemCategory2["APPLIANCES"] = "APPLIANCES";
  LineItemCategory2["EXTERIOR"] = "EXTERIOR";
  LineItemCategory2["MIRROR"] = "MIRROR";
  LineItemCategory2["MARBLE"] = "MARBLE";
  LineItemCategory2["FIREPLACE"] = "FIREPLACE";
  LineItemCategory2["MATERIAL"] = "MATERIAL";
  LineItemCategory2["BID_ITEM"] = "BID ITEM";
  LineItemCategory2["EQUIPMENT"] = "EQUIPMENT";
  LineItemCategory2["LABOR"] = "LABOR";
  LineItemCategory2["PPE"] = "PPE";
  return LineItemCategory2;
})(LineItemCategory || {});

// src/types/rule-engine/templates/multi_parent_recommendations.ts
var CHILD_ITEM_FIELDS = [
  {
    type: "lineItem",
    name: "lineItem",
    description: "The complement/recommendation line item to generate from the matched parent line items.",
    parameters: {
      canBeDifferentFromSource: true
    }
  },
  {
    type: "quantityFunction",
    name: "quantity",
    options: ["MULTIPLY", "USE_DEFAULT", "INHERIT", "FORMULA_FUNCTION"],
    description: "How to turn the summed-up parent formulas into the child's quantity. INHERIT uses the summed formula as-is. MULTIPLY multiplies the summed formula by the value. USE_DEFAULT uses the value as the raw formula. FORMULA_FUNCTION substitutes the summed formula into the value's {N} placeholder."
  },
  {
    type: "boolean",
    name: "isLikely",
    description: "When true, the generated line item is a recommendation instead of a complement."
  }
];
var ACTION_VARIABLES_TO_MATCH_ON = [
  "remove",
  "replace",
  "remove and replace",
  "detach",
  "detach and reset",
  "install only",
  "material only",
  "tear out"
];
var MULTI_PARENT_RECOMMENDATIONS = {
  name: "multi parent recommendations",
  id: "multi_parent_recommendations",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "enum",
        name: "parentCategories",
        values: [...Object.values(LineItemCategory)],
        isMultiSelect: true,
        description: "Match any line item whose template has one of these categories."
      },
      {
        type: "enum",
        name: "actionVariablesToMatchOn",
        values: [...ACTION_VARIABLES_TO_MATCH_ON],
        isMultiSelect: true,
        description: "Only match parent line items whose action variable is one of these. Used to filter down the matched parents."
      },
      {
        type: "array",
        name: "parentLineItems",
        description: "Match these specific line items (in addition to any category matches).",
        items: [
          {
            type: "lineItem",
            name: "lineItem",
            parameters: {
              enablePartialSelection: true
            }
          }
        ]
      },
      {
        type: "array",
        name: "excludedParentLineItems",
        description: "Never match these line items, even if they match a category or the parent line items list.",
        items: [
          {
            type: "lineItem",
            name: "lineItem",
            parameters: {
              enablePartialSelection: true
            }
          }
        ]
      },
      {
        type: "object",
        name: "child",
        properties: CHILD_ITEM_FIELDS
      },
      {
        type: "array",
        name: "overrides",
        items: [
          {
            type: "range",
            name: "summedParentQuantityRange",
            description: "The override is used when the summed-up quantity of all matched parent formulas falls within this range (start inclusive, end inclusive)."
          },
          {
            type: "boolean",
            name: "doNotCreateChild"
          },
          {
            type: "object",
            name: "child",
            properties: CHILD_ITEM_FIELDS
          }
        ]
      }
    ]
  }
};

// src/types/rule-engine/templates/multi_parent_transformations.ts
var MULTI_PARENT_TRANSFORMATIONS = {
  name: "multi parent transformations",
  id: "multi_parent_transformations",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "array",
        name: "existingLineItemParams",
        items: [
          {
            type: "lineItem",
            name: "lineItem",
            parameters: {
              enablePartialSelection: true
            }
          },
          {
            type: "boolean",
            name: "shouldKeep"
          },
          {
            type: "enum",
            name: "quantityFunction",
            values: ["USE_MAX", "USE_DEFAULT", "INHERIT_FROM_SPECIFIC_EXISTING"]
          },
          {
            type: "string",
            name: "quantityValue"
          }
        ]
      },
      {
        type: "array",
        name: "newLineItemParams",
        items: [
          {
            type: "lineItem",
            name: "lineItem"
          },
          {
            type: "enum",
            name: "quantityFunction",
            values: ["USE_MAX", "USE_DEFAULT", "INHERIT_FROM_SPECIFIC_EXISTING"]
          },
          {
            type: "string",
            name: "quantityValue"
          }
        ]
      }
    ]
  }
};

// src/types/rule-engine/templates/mutually_exclusive.ts
var MUTUALLY_EXCLUSIVE = {
  name: "mutually exclusive",
  id: "mutually_exclusive",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "array",
        name: "excluders",
        items: [
          {
            type: "lineItem",
            name: "excluder",
            parameters: {
              enablePartialSelection: true
            }
          }
        ]
      },
      {
        type: "lineItem",
        name: "excludee",
        parameters: {
          enablePartialSelection: true
        }
      }
    ]
  }
};

// src/types/rule-engine/templates/one_line_item_updates_another.ts
var ONE_LINE_ITEM_UPDATES_ANOTHER = {
  name: "one line item updates another",
  id: "one_line_item_updates_another",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "array",
        name: "triggerLineItems",
        description: "Trigger line items to match on. If multiple of these line items are present in a room, the one with the greatest formula is used as the source of truth for updating the target.",
        items: [
          {
            type: "lineItem",
            name: "triggerLineItem",
            parameters: {
              enablePartialSelection: true
            }
          }
        ]
      },
      {
        type: "lineItem",
        name: "targetLineItem",
        description: "The line item that gets updated by this rule. If multiple line items match in a room, the rule runs on each of them.",
        parameters: {
          enablePartialSelection: true
        }
      },
      {
        type: "boolean",
        name: "isExcluded",
        description: "If set to true, the target line item(s) will be marked as mutually excluded (same behavior as the mutually exclusive rule). This is only ever set to true; the rule never un-excludes a line item."
      },
      {
        type: "quantityFunction",
        name: "quantityFunction",
        description: "How the target line item's formula is updated. INHERIT: inherit the formula from the trigger line item with the highest formula, converted into the target's unit. TRIGGER_IS_FLOOR: the trigger's quantity is a floor for the target, so raise the target's quantity to the trigger's when the trigger is higher. TRIGGER_IS_CEILING: the trigger's quantity is a ceiling for the target, so lower the target's quantity to the trigger's when the trigger is lower. USE_DEFAULT: use the value typed into the text box as the raw formula. Leave unset to keep the target's formula unchanged.",
        options: ["INHERIT", "TRIGGER_IS_FLOOR", "TRIGGER_IS_CEILING", "USE_DEFAULT"]
      }
    ]
  }
};

// src/types/rule-engine/templates/paint_affected_and_continuous_surface.ts
var COMPLEMENT_FIELDS = [
  {
    type: "lineItem",
    name: "affectedMaterialComplementLineItem",
    description: "The affected-material complement line item to create for rooms with matching drywall."
  },
  {
    type: "string",
    name: "affectedMaterialComplementFormulaFunction",
    description: "DEPRECATED \u2014 will be removed soon. The formula function for the affected-material complement. Use {AM} for affected material and {CS} for continuous surface. Defaults to {AM} when blank."
  },
  {
    type: "lineItem",
    name: "continuousSurfaceComplementLineItem",
    description: "The continuous-surface complement line item to create for rooms with matching drywall."
  },
  {
    type: "string",
    name: "continuousSurfaceComplementFormulaFunction",
    description: "DEPRECATED \u2014 will be removed soon. The formula function for the continuous-surface complement. Use {AM} for affected material and {CS} for continuous surface. Defaults to {CS} when blank. The continuous-surface complement is skipped when the formula resolves to zero or less."
  },
  {
    type: "number",
    name: "drywallMultiplier",
    description: 'Multiplier applied to drywall replace area (1/2" walls and 5/8" ceilings) when computing the affected-material quantity. Defaults to 1.0.'
  },
  {
    type: "number",
    name: "floodCutFourFtMultiplier",
    description: "Multiplier applied to 4' flood-cut affected area. Defaults to 1.0."
  },
  {
    type: "number",
    name: "floodCutTwoFtMultiplier",
    description: "Multiplier applied to 2' flood-cut affected area. Defaults to 1.0."
  },
  {
    type: "number",
    name: "floodCutFourInMultiplier",
    description: 'Multiplier applied to 4" flood-cut affected area. Defaults to 1.0.'
  },
  {
    type: "boolean",
    name: "skipFourInFloodCut",
    description: 'When true, 4" flood cuts are excluded from the affected-material calculation (and from any continuous-surface subtraction of affected material). Defaults to false.'
  },
  {
    type: "boolean",
    name: "dontOverrideUserGeneratedLineItems",
    description: "When true, existing wall/ceiling paint line items that were generated directly from a scope note or PDF (i.e. not complements or likely recommendations) are left intact instead of being archived. Defaults to false."
  },
  {
    type: "enum",
    name: "continuousSurfaceComplementQuantityFunction",
    values: ["entire_continuous_surface", "unaffected_material", "remaining_unpainted_material"],
    description: "How to compute the continuous-surface complement quantity. entire_continuous_surface = {CS}. unaffected_material = {CS} - sum(area_i). remaining_unpainted_material = {CS} - sum(multiplier_i * area_i). Defaults to entire_continuous_surface."
  }
];
var PAINT_AFFECTED_AND_CONTINUOUS_SURFACE = {
  name: "paint affected and continuous surface",
  id: "paint_affected_and_continuous_surface",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      ...COMPLEMENT_FIELDS,
      {
        type: "array",
        name: "overrides",
        description: "Override the complement line items, per-surface multipliers, and continuous-surface quantity function (entire_continuous_surface | unaffected_material | remaining_unpainted_material) when run criteria match.",
        items: [
          {
            type: "object",
            name: "runCriteria",
            properties: RULE_RUN_CRITERIA
          },
          ...COMPLEMENT_FIELDS
        ]
      }
    ]
  }
};

// src/types/rule-engine/templates/split_line_items.ts
var SPLIT_LINE_ITEMS = {
  name: "split line items",
  id: "split_line_items",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      {
        type: "lineItem",
        name: "initialLineItem",
        parameters: {
          enablePartialSelection: true
        }
      },
      {
        type: "enum",
        name: "quantityFunction",
        values: ["SPLIT_EVENLY", "USE_DEFAULTS", "INHERIT"]
      },
      {
        type: "array",
        name: "finalLineItems",
        items: [
          {
            type: "lineItem",
            name: "lineItem",
            parameters: {
              sourceLineItemPath: "ruleInputs.initialLineItem",
              enableVariableOverride: true
            }
          },
          {
            type: "string",
            name: "quantityValue"
          }
        ]
      }
    ]
  }
};

// src/types/rule-engine/templates/update_after_hours.ts
var UPDATE_AFTER_HOURS_FIELDS = [
  {
    type: "array",
    name: "normalWorkHours",
    description: "Each Time Block represents the 'normal work hours' for a list of days. For example, if the normal work hours are 9am-5pm on Mon, Tue, Wed and 9am-4pm on Thu, Fri, then create two time blcoks where the first time block has Days=Mon, Tue, Wed, Start Time=9 and End Time=17 and the second time block has Days=Thu, Fri, Start Time=9 and End Time=16.",
    items: [
      {
        type: "enum",
        name: "days",
        values: Object.values(DayOfWeek),
        isMultiSelect: true
      },
      {
        type: "number",
        name: "startTime"
      },
      {
        type: "number",
        name: "endTime"
      }
    ]
  },
  {
    type: "enum",
    name: "holidays",
    values: Object.values(Holiday),
    isMultiSelect: true
  },
  {
    type: "array",
    name: "includedLineItems",
    description: "If set, the rule only runs on these line items. Leave empty to run on every line item.",
    items: [
      {
        type: "lineItem",
        name: "lineItem",
        parameters: {
          enablePartialSelection: true
        }
      }
    ]
  }
];
var UPDATE_AFTER_HOURS = {
  name: "update after hours",
  id: "update_after_hours",
  inputField: {
    name: "ruleInputs",
    type: "object",
    properties: [
      ...UPDATE_AFTER_HOURS_FIELDS,
      {
        type: "array",
        name: "overrides",
        description: "Run with different work hours / holidays / included line items when an estimate meets the override's run criteria. The first matching override wins; otherwise the base fields above are used.",
        items: [
          {
            type: "object",
            name: "runCriteria",
            properties: RULE_RUN_CRITERIA
          },
          ...UPDATE_AFTER_HOURS_FIELDS
        ]
      }
    ]
  }
};

export {
  EstimateStatus,
  XCELERATE_STATUSES,
  EstimateType,
  ESTIMATE_TYPE_LABELS,
  getEstimateTypeLabel,
  EstimaticsFileTypes,
  ScopeNoteSource,
  EstimateCreationSource,
  EstimateReferenceNumberType,
  NoteType,
  NOTE_TYPE_TO_ESTIMATE_TYPE,
  NOTE_TYPE_VALUES,
  getNoteTypeFromEstimateType,
  ResponsiveNoteTemplateVisitType,
  NoteFlowType,
  GeneralRoomOrder,
  VerboseSowPdfMode,
  Kind,
  TicSheetType,
  EstimateFieldsForExportHeader,
  TPARuleTypes,
  DayOfWeek,
  Holiday,
  RoomType,
  ESkipProcessingReason,
  ScopeTag,
  QueuedItemToProcessStatus,
  PdfFileFormat,
  EDrywallWidthCalculation,
  PFWidthCalculation,
  PCWidthCalculation,
  EExtraVariableValues,
  EExtraDataMappingType,
  FileErrorDummyPath,
  getQueuedItemToProcessStatusName,
  ESTIMATE_TYPE_TO_TAGS,
  RULE_TEMPLATE_IDS,
  INCLUDE_OR_EXCLUDE_VALUES,
  RuleQueryFieldType,
  RULE_RUN_CRITERIA,
  ADD_F9_NOTE,
  XACTIMATE_CATEGORIES,
  getDefaultActivity,
  BULK_TRANSFORM_LINE_ITEMS,
  COMPLEMENTS_AND_RECOMMENDATIONS,
  DEFAULT_QUANTITIES,
  GENERATE_FROM_ESTIMATE_FIELD,
  INHERIT_FORMULA,
  LINE_ITEM_TRANSFORMATION,
  MERGE_COMPLEMENTS,
  ISSUE_CONFIDENCE_THRESHOLD,
  LineItemCategory,
  MULTI_PARENT_RECOMMENDATIONS,
  MULTI_PARENT_TRANSFORMATIONS,
  MUTUALLY_EXCLUSIVE,
  ONE_LINE_ITEM_UPDATES_ANOTHER,
  PAINT_AFFECTED_AND_CONTINUOUS_SURFACE,
  SPLIT_LINE_ITEMS,
  UPDATE_AFTER_HOURS
};
//# sourceMappingURL=chunk-J32YGLMO.mjs.map